import {
  AfterViewInit,
  Component, ElementRef,
  Inject,
  OnDestroy,
  OnInit, ViewChild
} from '@angular/core';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../services/leads/leads-data.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  Articles, Ausschreibungstextes, Broschures, CadDatens, ConstructionTypes,
  ExtendedProperties,
  IContact, IUser, LeadComposerChangesModel,
  LeadData,
  LeadDataObject,
  LeadDocumentsModel,
  LeadsDataContactObject,
  LeadsHistory, Musters
} from '../../../models/leads/leads.model';
import { DateTimeHelper } from '../../../helper/date-time.helper';
import { LOCALE_KEY } from '../../../services/user-service/user-token.service';
import { ActionHelper } from '../../../helper/action.helper';
import { MatDialog } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../services/action/data.service';
import { IFileDocument } from '../../../models/shared.model';
import { ActionIconHelper } from '../../../helper/action-icon.helper';
import { AddressHelper } from '../../../helper/address.helper';
import { CONTACTS_DATA_SERVICE, ContactsDataService } from '../../../services/contacts/contacts-data.service';
import { ContactsModel, RelatedLeadsHistory } from '../../../models/contacts/contacts.model';
import { TextHelper } from '../../../helper/text.helper';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from "../../../services/resources/resources-data.service";
import { ResourceProvinces } from "../../../models/resources/resources.model";
import { UserProfileShareService } from "../../../services/shared-service/user-profile-share.service";
import { ComposerOfferOrOrder } from "../../../models/action.model";
import { OrderOfferTransferService } from "./extended-properties/order-offer-transfer.service";
import { LeadHelper } from '../../../helper/lead.helper';
import { combineLatest, filter, Subscription } from 'rxjs';
import {APPOINTMENT_CREATION_ERROR, CONTACTS_HAS_ADMIN_RIGHTS, IS_DUPLICATED_LEAD} from '../../../constants/constants';
import { ContactActionsComponent } from './contact-actions/contact-actions.component';
import { ContactOrderCardComponent } from './contact-order-card/contact-order-card.component';

@Component({
  selector: 'fi-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  standalone: false,
})
class ContactDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('fileContent') fileContent: ElementRef;
  @ViewChild('commentsContainer') commentsContainer: ElementRef;
  @ViewChild('tabsInner') tabsInner: ElementRef;
  @ViewChild(ContactActionsComponent) contactActionsComponent: ContactActionsComponent;
  @ViewChild(ContactOrderCardComponent) contactOrderCardComponent: ContactOrderCardComponent;

  showDetails = false;
  selectedTabIndex = -1;
  selectedCommentTabIndex = 0;
  mainLeadDetails: LeadData;
  selectedLeadDetails: LeadData;
  documents: LeadDocumentsModel[] = [];
  dateTimeHelper = DateTimeHelper;
  mainLeadId: number;
  closedTabsOpened = false;
  selectedLeadId: number;
  dateFormattedId: string;
  sendingComment: boolean;
  addressHelper = AddressHelper;
  attachments: IFileDocument[] = [];
  user: IUser;
  userId: number;
  oldHistoryTabsCount = 0;
  canEdit = true;

  selectedLinkedContactId: number;

  closedLeads: LeadDataObject[] = [];
  openedLeads: LeadDataObject[] = [];
  visibleBrokeredLeads: LeadDataObject[] = [];
  brokeringSourceLead: LeadDataObject | null = null;
  brokeringParentLeadId: number | null = null;
  commentText = '';

  actionHelper = ActionIconHelper;
  contactName = '';
  leadId: number;
  title: string;
  isDuplicateLead: boolean;
  isDealerPartner: boolean;
  isPremiumProjectPartner: boolean;
  isAdminUser: boolean;
  sideBarActive = false;
  extendedProperties: ExtendedProperties;
  leadOfferType = LeadHelper.LEAD_TYPE_OFFER;
  hideTabMore = false;
  articles: Articles[] = [];
  isMobile: Boolean;
  isClosed: Boolean;
  composerOffers: LeadComposerChangesModel[] = [];
  composerOrders: LeadComposerChangesModel[] = [];
  openOrdersAndOffersPopup: any;
  provinces: ResourceProvinces[];
  loadedLeadComposerOffers: LeadComposerChangesModel[] = [];
  loadNewLeadEmailData: boolean;
  mainOffer: LeadComposerChangesModel;
  mainOrder: LeadComposerChangesModel;
  offerAmountCount: number | undefined;
  orderAmountCount: number | undefined;
  constructionTypes: ConstructionTypes[];
  articlesLoaded = false;
  leadCompendiumHasAccess = undefined

  historyTabs = [
    'REQUEST_DETAIL_HISTORY_TAB_ALL_ENTRIES',
    'REQUEST_DETAIL_HISTORY_TAB_INQUIRY_TEXT',
    'REQUEST_DETAIL_HISTORY_TAB_NOTES',
    'REQUEST_DETAIL_HISTORY_TAB_OFFER_ORDER',
    'REQUEST_DETAIL_HISTORY_TAB_PRIVACY',
    'REQUEST_DETAIL_HISTORY_TAB_RELATED_ENQUIRIES'
  ];


  selectedContact: IContact;
  linkedContactToDisplay: IContact;
  leadContactToDisplay: IContact;
  consultationTypeName: string = '';
  consentAccredation: boolean;
  addressToDisplay: string;
  selectedLeadHistory: LeadsHistory[] = [];
  visibleHistoryTabs: string[] = [];
  showAddEnquiry = true;
  originalHistoryTabIndex: number = -1;
  relatedLeadsHistoryTabIndex: number = 5;
  relatedLeadsHistory: RelatedLeadsHistory[] = [];
  broschures: Broschures[] = [];
  ausschreibungstextes: Ausschreibungstextes[] = [];
  cadDatens: CadDatens[] = [];
  musters: Musters[] = [];


  private readonly leadTypeRelationshipManagement = LeadHelper.LEAD_TYPE_PLANER_RELATIONSHIP;
  private loadedLinkedContacts = new Map<number, ContactsModel>();
  private loadedLeadDetails = new Map<number, LeadData>();
  private loadedLeadHistories = new Map<number, LeadsHistory[]>();
  private histories: LeadsHistory[] = [];
  private articleKeyLeadTypeIds = new Map<string, number>();
  private filteredHistoryTabs = new WeakMap<LeadsHistory[], { tabs: string[], indexMapping: Map<number, number> }>();
  private routerSubscription: Subscription;
  private articlesSubscription: Subscription;
  private historySubscription: Subscription;
  private isFirstLoad = false;
  private alwaysShowActions = ['COMMENT_CREATE', 'LEAD_TYPE', 'COMPOSER_IMPORT', 'COMPOSER_MANUAL', 'LEAD_CONNECT', 'COMPENDIUM_REQUEST', 'COMPENDIUM_DENY', 'COMPENDIUM_ALLOW', 'COMPENDIUM_SEND', 'COMPENDIUM_DENIED', 'LEAD_SHARE', 'LEAD_SHARE_STOP', 'LEAD_REMINDER', 'CONSULTATION_CREATE'];

  constructor(
    private route: ActivatedRoute,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    private dialog: MatDialog,
    private router: Router,
    @Inject(RESOURCES_DATA_SERVICE) private resourcesDataService: ResourcesDataService,
    private readonly sharedProfileService: UserProfileShareService
  ) {

    this.onConstructorCreate();

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(_ => {
        if ( !this.isFirstLoad ) {
          this.isFirstLoad = true;
          return;
        }
        this.onConstructorCreate();
        this.onComponentInit();
      });
  }

  ngOnInit(): void {
    this.onComponentInit();
  }

  ngAfterViewInit() {
    this.isFirstLoad = true;
  }

  ngOnDestroy(): void {
    document.querySelector('body').classList.remove('sticky-header');
    ActionHelper.clearUnsavedChanges(this);
    this.routerSubscription?.unsubscribe();
    this.articlesSubscription?.unsubscribe();
    this.historySubscription?.unsubscribe();
  }

  getHistory( leadId: number, setHistory: boolean, onLoadHistory?: ( items: LeadsHistory[] ) => void ): void {
    this.documents = undefined;
    this.loadedLeadHistories.set(leadId, null);
    const contact = this.getLeadContactToDisplay();
    this.historySubscription = combineLatest(
      this.leadsDataService.getLeadHistory(leadId),
      this.contactsDataService.getContactHistory(+contact.Id)
    ).subscribe(( data ) => {
      if ( data[0].success ) {

        let leadEntries = data[0].data;
        let contactEntries = data[1].data ?? [];

        const creationEntry = leadEntries.find(x => x.ActionName === 'LEAD_CREATE');

        const contactCreationEntry = contactEntries[0];

        contactEntries = contactEntries.filter(x => x !== contactCreationEntry);

        if ( creationEntry ) {
          creationEntry.ConsentMarketing = contactCreationEntry?.ConsentMarketing ?? contact.ConsentMarketing;
          creationEntry.ConsentThirdParties = contactCreationEntry?.ConsentThirdParties ?? contact.ConsentThirdParties;
        }

        leadEntries.push(...contactEntries.map(( x ) => ({
          ...creationEntry,
          ActionName: 'PRIVACY_CHANGE',
          LeadEditor: x.Editor,
          Creator: x.Editor,
          ConsentMarketing: x.ConsentMarketing,
          ConsentThirdParties: x.ConsentThirdParties,
          CreTs: x.Timestamp,
          Comment: '',
        })));

        leadEntries.sort(( a, b ) => b.CreTs.localeCompare(a.CreTs));
        leadEntries = leadEntries.filter(x => x !== creationEntry);

        if ( creationEntry ) {
          leadEntries.push(creationEntry);
        }
        this.loadedLeadHistories.set(leadId, leadEntries);
        if ( setHistory ) {
          this.selectedLeadHistory = this.filterSelectedLeadHistoryByStateName(this.loadedLeadHistories.get(leadId) ?? this.histories ?? []);
          this.setVisibleHistoryTabs();
        }
        this.mainOrder = this.loadedLeadComposerOffers.find(offer => offer.IsOrder);
        this.mainOffer = this.loadedLeadComposerOffers.find(offer => !offer.IsOrder && offer.IsMain);
        onLoadHistory?.(this.selectedLeadHistory);
      }
    });
  }

  getRelatedLeads() {
    const contact = this.getLeadContactToDisplay();
    if ( contact && this.isPlanerUser() ) {
      this.contactsDataService.getRelatedLeads(+contact.Id).subscribe(( { success, data } ) => {
        if ( success ) {
          this.relatedLeadsHistory = this.sortRelatedLeadHistory(data);
        }
      })
    }
  }

  getFatcsStatus( leadId: number ): void {
    this.leadsDataService.getLeadFacts(leadId).subscribe(( { success, data } ) => {
      if ( success ) {
        this.leadCompendiumHasAccess = data.includes('COMPENDIUM_ACCESS')
      } else {
        this.leadCompendiumHasAccess = undefined;
      }
    });
  }

  getMainLeadOnly() {
    this.leadsDataService.getLeadById(this.selectedLeadDetails.Lead.Id).subscribe(( { success, data } ) => {
      if ( success ) {
        this.mainLeadDetails = data;
      }
    });
  }

  getMainLead( firstLoad: boolean = false, refreshCompendiumFacts: boolean = firstLoad ): void {
    this.leadsDataService.getLeadById(this.mainLeadId).subscribe(( { success, data, apiStatus, httpStatus } ) => {
      if ( success ) {

        // Only dealer partners get the accept overlay, otherwise the preview page redirects back here
        // No enquiry info (someone else accepted first, or no read permission) is handled there too
        const requiresAccept = !data.Lead || (data.Lead.RequiresConfirmation && +data.Lead.EditorId === +this.userId);
        if ( firstLoad && this.isDealerPartner && requiresAccept ) {
          this.router.navigate(['/request-invitation-preview/' + this.mainLeadId]);
          return;
        }
        if ( !data.Lead ) {
          this.router.navigate(['/not-allowed-details'], { replaceUrl: true });
          return;
        }
        if ( firstLoad ) {
          this.selectedLeadDetails = data;
          this.linkedContactToDisplay = data.Contact;
          this.articles = data.Articles;
          this.getRelatedLeads();
        }

        if ( refreshCompendiumFacts ) {
          this.getRelationshipManagementFacts(data.AllLeads);
        }

        this.mainLeadDetails = data;
        this.loadedLeadDetails.clear();
        this.loadedLeadHistories.clear();
        this.loadedLinkedContacts.clear();
        this.loadedLeadDetails.set(this.mainLeadDetails.Lead.Id, this.mainLeadDetails);
        this.filterArticles();
        this.visibleBrokeredLeads = [];
        this.brokeringSourceLead = null;
        this.brokeringParentLeadId = null;
        this.closedLeads = [];
        this.openedLeads = [];
        if (this.mainLeadDetails.Lead.Done) {
          this.closedLeads = [this.mainLeadDetails.Lead];
        } else {
          this.openedLeads = [this.mainLeadDetails.Lead];
        }
        data.AllLeads.filter(item => item.Id !== this.mainLeadId).forEach(item => {
          if ( item.Done ) {
            this.closedLeads.push(item);
            return;
          }
          this.openedLeads.push(item);
        });
        this.openedLeads = this.sortClosedLeads(this.openedLeads);
        this.closedLeads = this.sortClosedLeads(this.closedLeads);
        this.setTabIndex();
      } else {
        if (httpStatus === 400 && (apiStatus === 404 || apiStatus === 403)) {
          this.router.navigate(['/not-allowed-details/']);
        }
      }
    });
  }

  onDuplicateChecked(): void {
    sessionStorage.setItem(IS_DUPLICATED_LEAD, 'false');
    this.isDuplicateLead = false;
    this.getMainLead(false);
  }

  onLeadConnected(): void {
    this.getMainLead(false);
  }

  onActionCompleted( actionName: string ): void {
    this.hideTabMore = true;
    const refreshCompendiumFacts = actionName === 'COMPENDIUM_ALLOW' || actionName === 'COMPENDIUM_DENY';
    this.getMainLead(false, refreshCompendiumFacts);
    this.getExtendedPropertiesByLeadId();
  }

  onActionRequested( data ): void {
    if (data.action.Name === 'OFFER_EDIT') {
      this.contactOrderCardComponent.onOfferOrderEdit();
      return;
    }
    this.contactActionsComponent.doAction(data.action, data.successCallback)
  }

  onEditOfferOrderActionRequested( data ): void {
    this.contactActionsComponent.doAction(data.action, data.successCallback)
  }

  onConstructionTypeIdUpdated( id: number ): void {
    this.loadedLeadDetails.get(this.selectedLeadId).Lead.ConstructionTypeId = id;
  }

  onLoadComposerOffersRequested( data ): void {
    if (data.placeOrder) {
      // reset selected lead detail to get new one from API
      const id = this.selectedLeadId;
      this.loadedLeadDetails.delete(id);
      this.getSelectedLeadDetails();
    }
    this.loadComposerOffers(data.event, data.load1, data.load2);
  }

  onLeadUpdated( id: number ): void {
    if ( !this.isDuplicateLead ) {
      // TODO why this is needed check case when editing another selected lead
      // this.leadsDataService.getLeadById(id).subscribe(( { success, data } ) => {
      //   if ( success ) {
      //     this.loadedLeadDetails.set(id, data);
      //     this.filterArticles();
      //   }
      // });
    }
    this.getMainLead(false);
    this.getExtendedPropertiesByLeadId();
  }

  openContactDetails( id?: number ): void {
    if ( id && !this.loadedLinkedContacts.has(id) ) {
      this.loadedLinkedContacts.set(id, null);
      this.contactsDataService.getContacts(id).subscribe(( { data, success } ) => {
        this.selectedLinkedContactId = id;

        if ( success ) {
          this.loadedLinkedContacts.set(id, data);
          this.linkedContactToDisplay = this.getLinkedContactToDisplay();
        }
      });
    } else {
      this.selectedLinkedContactId = id;
      this.linkedContactToDisplay = this.getLinkedContactToDisplay();
    }
  }

  openCreateLeadDialog( contact: LeadsDataContactObject ): void {
    ActionHelper.openNewRequestDialog(this.dialog, this.router, contact);
  }

  onGetMainLead(): void {
    this.getMainLead(true)
  }

  onSendComment(): void {
    if ( this.selectedLeadId ) {
      this.sendingComment = true;

      this.actionDataService.createComment(this.selectedLeadId, TextHelper.makeUrlsLinks(this.commentText), this.attachments).subscribe(( { success } ) => {
        if ( success ) {
          this.getHistory(this.selectedLeadId, true);
          ActionHelper.initializeOrResetUnsavedChanges(this);
        }

        this.sendingComment = false;
      });
    }
  }

  onCommentTabChange(): void {
    this.setVisibleHistoryTabs();
  }

  onTabChange( tabIndex: number ): void {
    this.documents = undefined;
    this.histories = undefined;
    this.selectedLinkedContactId = undefined;
    this.selectedCommentTabIndex = 0;
    const openedLeadsLength = this.openedLeads.length;

    if ( tabIndex >= openedLeadsLength ) {
      tabIndex -= openedLeadsLength;

      const connectedLeadsLength = this.mainLeadDetails.ConnectedLeads.length;
      if ( tabIndex >= connectedLeadsLength ) {
        tabIndex -= connectedLeadsLength;
        this.closedTabsOpened = true;
        this.setChangedTabLeadData(this.closedLeads[tabIndex]);
        return;
      }

      this.setChangedTabLeadData(this.mainLeadDetails.ConnectedLeads[tabIndex]);
      return;
    }

    this.setChangedTabLeadData(this.openedLeads[tabIndex]);
  }

  onBrokeredTabSelected( lead: LeadDataObject ): void {
    this.documents = undefined;
    this.histories = undefined;
    this.selectedLinkedContactId = undefined;
    this.selectedCommentTabIndex = 0;
    this.selectedTabIndex = -1;
    this.setChangedTabLeadData(lead);
  }

  onBrokeringTargetSelected( leadId: number ): void {
    const tabs = [...this.openedLeads, ...this.mainLeadDetails.ConnectedLeads, ...this.closedLeads];
    const tabIndex = tabs.findIndex(lead => lead.Id === leadId);

    if ( tabIndex !== -1 ) {
      this.selectedTabIndex = tabIndex;
      this.onTabChange(tabIndex);
      window.scrollTo(0, 0);
      return;
    }

    const brokeredLead = this.visibleBrokeredLeads.find(lead => lead.Id === leadId)
      // a failed brokering target gets no tab of its own, but the comment link still has to open it
      ?? this.revealHiddenBrokeredLead(leadId);

    if ( brokeredLead ) {
      this.onBrokeredTabSelected(brokeredLead);
      window.scrollTo(0, 0);
    }
  }

  deleteHistoryItem( i: number ): void {
    this.histories.splice(i, 1);
    this.filteredHistoryTabs.delete(this.histories);
  }

  scrollToHistoryStart( id: string ): void {
    const data = this.getUpdatedHistoryTabData();
    this.selectedCommentTabIndex = data.tabs?.indexOf('REQUEST_DETAIL_HISTORY_TAB_PRIVACY') ?? 0;

    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  }

  private onConstructorCreate(): void {
    ActionHelper.initializeOrResetUnsavedChanges(this);
    this.getArticleLists();

    OrderOfferTransferService.loadComposerOffers.subscribe(data => {
      this.loadComposerOffers(data);
    }).unsubscribe();

    OrderOfferTransferService.isClosed.subscribe(data => {
      this.isClosed = data;
    });
    OrderOfferTransferService.isMobile.subscribe(data => {
      this.isMobile = data;
    });
    OrderOfferTransferService.composerOffers.subscribe(data => {
      this.composerOffers = data;
    });
    OrderOfferTransferService.composerOrders.subscribe(data => {
      this.composerOrders = data;
    });
    OrderOfferTransferService.openOrdersAndOffersPopup.subscribe(data => {
      this.openOrdersAndOffersPopup = data;
    })

    // tslint:disable-next-line:radix
    this.selectedLeadId = this.mainLeadId = parseInt(this.route.snapshot.paramMap.get('id'));

    this.isDuplicateLead = sessionStorage.getItem(IS_DUPLICATED_LEAD) === 'true';

    this.sharedProfileService.getIsDealerPartner().subscribe(isDealerPartner => {
      this.isDealerPartner = isDealerPartner;
    });

    this.sharedProfileService.getIsPremiumProjectPartner().subscribe(isPremiumProjectPartner => {
      this.isPremiumProjectPartner = isPremiumProjectPartner;
    });

    if ( !this.isDuplicateLead ) {
      this.sharedProfileService.getProfile().subscribe(data => {
        this.user = data.User;
        this.userId = this.user.Id;
      });

      this.getMainLead(true);

    } else {
      this.getDuplicateLead();
    }

    this.isMobile = window.innerWidth < 768;
    this.getProvinces();
    this.getConstructionTypes();
  }

  private getRelationshipManagementFacts( allLeads: LeadDataObject[] ) {
    const hasRelationShipLead = allLeads.find(lead => lead.LeadTypeId === this.leadTypeRelationshipManagement);
    this.getFatcsStatus(hasRelationShipLead ? hasRelationShipLead.Id : this.mainLeadId);
  }

  private isPlanerUserAndSharedRelationShipLead(): boolean {
    if ( !this.selectedLeadDetails ) {
      return false;
    }
    return this.isPlanerUser() &&
      this.selectedLeadDetails.Lead.LeadTypeId === this.leadTypeRelationshipManagement &&
      this.selectedLeadDetails.Lead.IsShared;
  }

  private isPlanerUser(): boolean {
    return !this.isDealerPartner;
  }

  private onComponentInit(): void {
    window.scroll({ top: 0 });
    this.checkAppointmentCreation();
    this.sharedProfileService.getProfile().subscribe(data => {
      this.user = data.User;
      this.userId = this.user.Id;
    });
    this.isAdminUser = this.sharedProfileService.hasRight(CONTACTS_HAS_ADMIN_RIGHTS);
  }

  private setChangedTabLeadData( lead: LeadDataObject ): void {
    this.selectedContact = lead.Contact as any;
    this.selectedLeadId = lead.Id;
    this.dateFormattedId = lead.DateFormattedId;
    this.canEdit = !lead.Done;
    this.getSelectedLeadDetails();
    this.getExtendedPropertiesByLeadId();
  }

  private getSelectedLeadDetails(): void {
    const id = this.selectedLeadId;
    if ( !this.loadedLeadDetails.has(id) ) {
      this.loadedLeadDetails.set(id, null);

      if ( !this.isDuplicateLead ) {
        this.leadsDataService.getLeadById(id).subscribe(( { success, data } ) => {
          if ( success ) {
            this.setSelectedLeadData(id, data)
          }
        });
      } else {
        this.setSelectedLeadData(id, this.mainLeadDetails)
      }
    } else {
      this.setSelectedLeadData(id)
    }
  }

  private getSelectedLeadHistory(): void {
    if ( this.isDuplicateLead ) {
      return;
    }
    if ( this.loadedLeadHistories.get(this.selectedLeadId) ) {
      this.histories = this.loadedLeadHistories.get(this.selectedLeadId) ?? [];
      this.selectedLeadHistory = this.filterSelectedLeadHistoryByStateName(this.histories ?? []);
      this.setVisibleHistoryTabs();
    } else {
      this.getHistory(this.selectedLeadId, true);
    }
  }

  private setSelectedLeadData( id: number, data?: LeadData ): void {
    if ( data ) {
      this.loadedLeadDetails.set(id, data);
      this.filterArticles();
    }
    this.selectedLeadDetails = this.loadedLeadDetails.get(id);
    this.articles = this.selectedLeadDetails.Articles;
    this.consentAccredation = this.selectedLeadDetails.AllLeads?.find(item => item.Id === this.selectedLeadDetails?.Lead.Id)?.ConsentAccredation;
    this.addressToDisplay = this.getAddressToDisplay();
    this.linkedContactToDisplay = this.getLinkedContactToDisplay();
    this.getSelectedLeadHistory();
    this.getConsultationTypeName(this.constructionTypes);
    this.updateVisibleBrokeredLeads();
    this.updateBrokeringSourceLead();
  }

  /**
   * A brokered lead only knows its origin through BrokeringInfo.SourceLeadId, so the lead
   * behind it is loaded separately to be offered as an additional tab.
   */
  private updateBrokeringSourceLead(): void {
    // the source lead has no source of its own, so keep its tab while the user is browsing it
    if ( this.brokeringSourceLead?.Id === this.selectedLeadId ) {
      return;
    }

    const sourceLeadId = this.selectedLeadDetails?.BrokeringInfo?.SourceLeadId;

    if ( !sourceLeadId || this.isLeadShownAsTab(sourceLeadId) ) {
      this.brokeringSourceLead = null;
      return;
    }

    if ( this.brokeringSourceLead?.Id === sourceLeadId ) {
      return;
    }

    const loadedSourceLead = this.loadedLeadDetails.get(sourceLeadId)?.Lead;
    if ( loadedSourceLead ) {
      this.brokeringSourceLead = { ...loadedSourceLead, isBrokeredLead: true } as LeadDataObject;
      return;
    }

    this.brokeringSourceLead = null;
    this.leadsDataService.getLeadById(sourceLeadId).subscribe(( { success, data } ) => {
      // the user may have switched to another lead while the source lead was loading,
      // and a source lead the user has no access to simply stays hidden
      if ( !success || this.selectedLeadDetails?.BrokeringInfo?.SourceLeadId !== sourceLeadId ) {
        return;
      }

      this.loadedLeadDetails.set(sourceLeadId, data);
      this.brokeringSourceLead = { ...data.Lead, isBrokeredLead: true } as LeadDataObject;
    });
  }

  private isLeadShownAsTab( leadId: number ): boolean {
    return [
      ...this.openedLeads,
      ...this.closedLeads,
      ...(this.mainLeadDetails?.ConnectedLeads ?? []),
      ...this.visibleBrokeredLeads,
    ].some(lead => lead.Id === leadId);
  }

  private revealHiddenBrokeredLead( leadId: number ): LeadDataObject | undefined {
    const hiddenLead = [this.selectedLeadDetails, ...this.loadedLeadDetails.values()]
      .map(details => details?.BrokeredLeads?.find(lead => lead.Id === leadId))
      .find(lead => !!lead);

    if ( !hiddenLead ) {
      return undefined;
    }

    const revealedLead = { ...hiddenLead, isBrokeredLead: true } as LeadDataObject;
    this.visibleBrokeredLeads = [...this.visibleBrokeredLeads, revealedLead];
    this.brokeringParentLeadId ??= this.selectedLeadId;

    return revealedLead;
  }

  private updateVisibleBrokeredLeads(): void {
    // Selecting a lead that's already shown as one of the current brokered siblings
    // shouldn't re-derive the list from that lead's own (likely empty) BrokeredLeads -
    // it would wipe out the sibling tabs the user is still browsing.
    if ( this.visibleBrokeredLeads.some(lead => lead.Id === this.selectedLeadId) ) {
      return;
    }

    const brokeredLeads = this.selectedLeadDetails?.BrokeredLeads;
    if ( !brokeredLeads?.length ) {
      this.visibleBrokeredLeads = [];
      this.brokeringParentLeadId = null;
      return;
    }

    const existingIds = new Set([...this.openedLeads, ...this.closedLeads].map(lead => lead.Id));
    this.visibleBrokeredLeads = brokeredLeads
      // a partner that never took the enquiry over is not worth a tab
      .filter(lead => !lead.BrokeringFailed)
      .filter(lead => !existingIds.has(lead.Id))
      .map(lead => ({ ...lead, isBrokeredLead: true } as LeadDataObject));
    this.brokeringParentLeadId = this.visibleBrokeredLeads.length ? this.selectedLeadId : null;
  }

  private setVisibleHistoryTabs(): void {
    const updatedHistoryData = this.getUpdatedHistoryTabData();
    this.visibleHistoryTabs = updatedHistoryData?.tabs ?? [];
    this.originalHistoryTabIndex = updatedHistoryData.indexMapping.get(this.selectedCommentTabIndex) ?? -1
  }

  private getDuplicateLead(): void {

    this.leadsDataService.getDuplicateLeadById(this.mainLeadId).subscribe(( { success, data } ) => {
      if ( success ) {

        this.mainLeadDetails = {
          Lead: data.Lead,
          Contact: data.ImportedContact,
          Creator: {
            Id: data.Lead.CreatorId,
            FirstName: data.Lead.CreatorName.split(' ')[0],
            LastName: data.Lead.CreatorName.split(' ')[1]
          },
          Editor: {
            Id: data.Lead.EditorId,
            FirstName: data.Lead.EditorName.split(' ')[0],
            LastName: data.Lead.EditorName.split(' ')[1]
          }
        };

        this.loadedLeadDetails.set(this.mainLeadDetails.Lead.Id, this.mainLeadDetails);
        this.selectedLeadDetails = this.mainLeadDetails;
        this.filterArticles();
        this.openedLeads = [];
        this.closedLeads = [];
        if (this.mainLeadDetails.Lead.Done) {
          this.closedLeads = [this.mainLeadDetails.Lead];
        } else {
          this.openedLeads = [this.mainLeadDetails.Lead];
        }
      }
    });
  }

  private getExtendedPropertiesByLeadId(): void {
    this.loadComposerOffers();
    this.mainOffer = this.loadedLeadComposerOffers.find(offer => !offer.IsOrder && offer.IsMain);
    this.mainOrder = this.loadedLeadComposerOffers.find(offer => offer.IsOrder);
    this.leadsDataService.getExtendedPropertiesByLeadId(this.selectedLeadId).subscribe(( { success, data } ) => {
      if ( success ) {
        this.extendedProperties = data;
      }
    });
  }

  private checkAppointmentCreation(): void {

    if ( sessionStorage.getItem(APPOINTMENT_CREATION_ERROR) === 'true' ) {
      const errorSnippet = {
        title: 'LEAD_ERRORMSG_APPOINTMENT_CREATE_MOBILE_HEADER',
        description: 'LEAD_ERRORMSG_APPOINTMENT_CREATE_MOBILE'
      };
      ActionHelper.showAction('ERROR', this.dialog, {
        errorSnippets: errorSnippet
      }).afterClosed().subscribe(_ => {
        sessionStorage.removeItem(APPOINTMENT_CREATION_ERROR)
      });
    }
  }

  private getConstructionTypes(): void {
    this.leadsDataService.getConstructionTypes().subscribe(( { success, data } ) => {
      if ( success ) {
        this.constructionTypes = data.filter(item => !item.Inactive);
        this.getConsultationTypeName(this.constructionTypes)
      }
    });
  }

  private getConsultationTypeName( constructionTypes: ConstructionTypes[] ): void {
    if ( constructionTypes && this.selectedLeadDetails ) {
      this.consultationTypeName = constructionTypes?.find(x => x.Id === this.selectedLeadDetails.Lead?.ConstructionTypeId)?.Description ?? '';
    }
  }

  private loadComposerOffers(
    $event?: ComposerOfferOrOrder,
    onLoadComposer?: ( items: LeadComposerChangesModel[], ) => void,
    onLoadHistory?: ( items: LeadsHistory[], ) => void
  ): void {
    if ( $event ) {
      this.getHistory(this.selectedLeadId, false, onLoadHistory);
    }
    this.getComposerOffersAndOrders(onLoadComposer);
  }

  private getComposerOffersAndOrders( onLoadComposer?: ( items: LeadComposerChangesModel[] ) => void ): void {
    this.leadsDataService.getLeadComposerOffers(this.selectedLeadId).subscribe(( { success, data } ) => {
      if ( success ) {
        this.loadedLeadComposerOffers = data;
        this.mainOffer = this.loadedLeadComposerOffers.find(offer => !offer.IsOrder && offer.IsMain);
        this.mainOrder = this.loadedLeadComposerOffers.find(offer => offer.IsOrder);
        this.composerOrders = this.loadedLeadComposerOffers.filter(x => x.IsOrder);
        this.composerOffers = this.loadedLeadComposerOffers.filter(x => !x.IsOrder);
        this.offerAmountCount = this.loadedLeadComposerOffers.filter(offer => !offer.IsOrder && offer.IsMain)?.reduce(( acc, data ) => {
          acc += data.Amount;
          return acc;
        }, 0)
        this.orderAmountCount = this.loadedLeadComposerOffers.filter(order => order.IsOrder)?.reduce(( acc, data ) => {
          acc += data.Amount;
          return acc;
        }, 0)
        onLoadComposer?.(this.loadedLeadComposerOffers);
      }
    });
  }

  private getArticleLists(): void {
    const locale = sessionStorage.getItem(LOCALE_KEY);

    this.articlesSubscription = combineLatest(
      [this.leadsDataService.getBrochures(locale),
        this.leadsDataService.getAusschreibungstextes(locale),
        this.leadsDataService.getCadDatens(locale),
        this.leadsDataService.getMusters(locale),]
    ).subscribe(data => {
      if ( data[0].success ) {
        this.broschures = data[0].data;
        data[0].data.forEach(x => this.articleKeyLeadTypeIds.set('broch_' + x.key, LeadHelper.LEAD_TYPE_BROCHURE));
      }

      if ( data[1].success ) {
        this.ausschreibungstextes = data[1].data;
        data[1].data.forEach(x => this.articleKeyLeadTypeIds.set('aussch_' + x.key, LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE));
      }

      if ( data[2].success ) {
        this.cadDatens = data[2].data;
        data[2].data.forEach(x => this.articleKeyLeadTypeIds.set('cad_' + x.key, LeadHelper.LEAD_TYPE_CAD_DATEN));
      }

      if ( data[3].success ) {
        this.musters = data[3].data;
        data[3].data.forEach(x => this.articleKeyLeadTypeIds.set('must_' + x.key, LeadHelper.LEAD_TYPE_MUSTER));
      }

      this.filterArticles();
      this.articlesLoaded = true;
    })
  }

  private filterArticles(): void {
    this.loadedLeadDetails.forEach(( lead ) => {
      if ( !lead ) {
        return;
      }

      const oldArticles = lead.Articles;

      if (
        [
          LeadHelper.LEAD_TYPE_BROCHURE,
          LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE,
          LeadHelper.LEAD_TYPE_CAD_DATEN,
          LeadHelper.LEAD_TYPE_MUSTER
        ].includes(lead.Lead?.LeadTypeId)
      ) {
        let prefix = 'broch_'

        switch ( lead.Lead?.LeadTypeId ) {
          case LeadHelper.LEAD_TYPE_AUSSCHREIBUNGSTEXTE:
            prefix = 'aussch_';
            break
          case LeadHelper.LEAD_TYPE_CAD_DATEN:
            prefix = 'cad_';
            break
          case LeadHelper.LEAD_TYPE_MUSTER:
            prefix = 'must_';
            break
        }

        lead.Articles = oldArticles?.filter(x => {
          // return this.articleKeyLeadTypeIds.get(prefix + x.Article)
          return (this.articleKeyLeadTypeIds.get(prefix + x.Article) ?? lead.Lead?.LeadTypeId) === lead.Lead?.LeadTypeId
        });
      } else {
        lead.Articles = [];
      }
      if ( this.articles && oldArticles === this.articles ) {
        this.articles = lead.Articles;
      }
    });
  }

  private filterSelectedLeadHistoryByStateName(history: LeadsHistory[]) {
    return history.filter(
      el =>
        this.alwaysShowActions.includes(el.ActionName) ||
        !el.LeadStateName?.endsWith('_DONE')
    );
  }

  private getProvinces(): void {
    this.resourcesDataService.getResourceProvinces().subscribe(( { success, data } ) => {
      if ( success ) {
        this.provinces = data;
        AddressHelper.setProvinces(data);
        this.addressToDisplay = this.getAddressToDisplay();
      }
    });
  }

  private setTabIndex(): void {
    const tabs = [...this.openedLeads, ...this.mainLeadDetails.ConnectedLeads, ...this.closedLeads];

    const tabIndex = tabs.findIndex(( el ) =>
      (el.Id === this.selectedLeadId)
    );

    setTimeout(() => {
      if ( tabIndex === -1 ) {
        // Currently selected lead is a brokered (foreign) lead, not part of the base tabs -
        // just refresh its own details instead of indexing into openedLeads/closedLeads.
        this.selectedTabIndex = -1;
        this.getSelectedLeadDetails();
        this.hideTabMore = false;
        return;
      }

      this.selectedTabIndex = tabIndex;
      this.onTabChange(this.selectedTabIndex);
      this.hideTabMore = false;
    }, 400);
  }

  private getUpdatedHistoryTabData(): { tabs: string[], indexMapping: Map<number, number> } {
    const history = this.selectedLeadHistory;

    if ( !history ) {
      return null;
    }

    let data = this.filteredHistoryTabs.get(history);

    if ( !data ) {
      data = { tabs: [], indexMapping: new Map() };
      let visibleIndex = -1

      for ( let i = 0; i < this.historyTabs.length; ++i ) {
        if ( i === 0 ) {
          if ( !history.length ) {
            continue;
          }
        }

        if ( i === 1 || i === 4 ) {
          if ( !history.some(item => item.ActionName === 'LEAD_CREATE' || item.ActionName === 'PRIVACY_CHANGE') ) {
            continue;
          }
        }

        if ( i === 2 ) {
          if ( !history.some(item => item.ActionName === 'COMMENT_CREATE') ) {
            continue;
          }
        }

        if ( i === 3 ) {
          if (
            !history.some(
              item =>
                item.ActionName.startsWith('OFFER_') ||
                item.ActionName.startsWith('ORDER_') ||
                item.ActionName.startsWith('COMPOSER_')) ) {
            continue;
          }
        }

        if ( i === 5 && ( !this.isPlanerUserAndSharedRelationShipLead() || !this.relatedLeadsHistory.length) ) {
          continue;
        }

        ++visibleIndex;
        data.tabs.push(this.historyTabs[i]);
        data.indexMapping.set(visibleIndex, i);

      }

      this.filteredHistoryTabs.set(history, data);
    }

    if ( data.tabs.length !== this.oldHistoryTabsCount ) {
      this.oldHistoryTabsCount = data.tabs.length;
      const oldIndex = Math.min(Math.max(0, this.selectedCommentTabIndex), data.tabs.length - 1);
      this.selectedCommentTabIndex = -1;

      if ( history === this.selectedLeadHistory ) {
        this.selectedCommentTabIndex = oldIndex;
      }

      if ( this.selectedCommentTabIndex < 0 ) {
        this.selectedCommentTabIndex = 0;
      }
    }

    return data;
  }

  private getLeadContactToDisplay(): IContact {
    this.leadContactToDisplay = this.selectedLeadDetails?.Contact ?? this.selectedContact;
    return this.leadContactToDisplay;
  }

  private getLinkedContactToDisplay(): IContact {
    if ( this.selectedLinkedContactId && this.loadedLinkedContacts.get(this.selectedLinkedContactId) ) {
      return this.loadedLinkedContacts.get(this.selectedLinkedContactId) as any;
    }

    return this.getLeadContactToDisplay();
  }

  private getLeadAddressToDisplay(): string {
    const address = this.selectedLeadDetails?.Lead?.Address;
    const leadAddress = ( !address || Object.keys(address).length === 0)
      ? this.selectedContact
      : address;
    let provinceCode = leadAddress?.ProvinceCode;
    const provinceText = leadAddress?.ProvinceText ?? '';
    let province = provinceCode ? this.provinces?.find(item => item.Code === provinceCode)?.Text : provinceText;
    province = (province ? ', ' + province : '')
    return this.addressHelper.getLeadAddress({
      ...leadAddress,
      Commission: ''
    }, province);
  }

  private getLeadContactAddressToDisplay(): string {
    let province = this.selectedLeadDetails?.Lead?.Contact?.ProvinceText;
    province = (province ? ', ' + province : '')
    return this.addressHelper.getLeadAddress(this.leadContactToDisplay, province)
  }

  private getAddressToDisplay(): string {
    let leadAddress = this.getLeadAddressToDisplay() ?? '';
    let leadContactAddress = this.getLeadContactAddressToDisplay() ?? '';

    const commission = this.selectedLeadDetails?.Lead.Commission;

    if ( commission ) {
      if ( leadAddress ) {
        leadAddress = `${commission}, ${leadAddress}`;
      } else if ( leadContactAddress ) {
        leadContactAddress = `${commission}, ${leadContactAddress}`;
      } else {
        leadAddress = leadContactAddress = commission;
      }
    }

    return leadAddress ? leadAddress : leadContactAddress;
  }

  private sortRelatedLeadHistory( history: RelatedLeadsHistory[] ): RelatedLeadsHistory[] {
    return history.sort(( a, b ) => {
      // Convert CreTs strings to Date objects for comparison
      const dateA = new Date(a.CreTs);
      const dateB = new Date(b.CreTs);

      // Sort in descending order (newest first)
      return dateB.getTime() - dateA.getTime();
    });
  }

  private sortClosedLeads( leads: LeadDataObject[] ): LeadDataObject[] {
    return leads.sort(( a, b ) => {
      // Convert CreTs strings to Date objects for comparison
      const dateA = new Date(a.CreTS);
      const dateB = new Date(b.CreTS);

      // Sort in descending order (newest first)
      return dateB.getTime() - dateA.getTime();
    });
  }
}

export default ContactDetailsComponent
